export default "__VITE_ASSET__CNby4SIY__"